import { render, staticRenderFns } from "./btn-annual-declaration.vue?vue&type=template&id=3c62372d"
import script from "./btn-annual-declaration.vue?vue&type=script&lang=js"
export * from "./btn-annual-declaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports